const triggerSelector = '.splx-pagination-trigger';
const blockSelector = '[data-splx-block-id]';
const nextButtonSelector = '.splx-pagination .next';
const listSelector = '.splx-list';

function triggerPagination(e) {
  e.preventDefault();
  const $trigger = $(this);
  const $block = $trigger.closest(blockSelector);
  const $nextButton = $block.find(nextButtonSelector);
  const $list = $block.find(listSelector);

  if($nextButton.length) {
    $.ajax({
      type: 'GET',
      url: $nextButton.attr('href'),
      success: function(response) {
        const $response = $(response);
        $list.append($response.find(listSelector).html());
        const $nextNextButton = $response.find(nextButtonSelector);
        if ($nextNextButton.length) {
          $nextButton.attr('href', $nextNextButton.attr('href'));
        } else {
          $trigger.remove();
        }
      },
    });
  }
}

export default function() {
  $(triggerSelector).on('click', triggerPagination);
}



// WEBPACK FOOTER //
// ./scripts/components/splx-pagination.js